import { valueOf } from "@/types/common";

// BE は smallint で保持する（1:カテゴリ 2:職種 3:作業）。
// 0 は使わない: 階層判定で falsy 扱いになり「親なし」と区別できなくなるため。
export const OCCUPATION_TYPE = {
  CATEGORY: 1,
  SHOKUSHU: 2,
  SAGYO: 3,
} as const;

export type TOccupationType = valueOf<typeof OCCUPATION_TYPE>;

// BE は smallint で保持する（1:技能検定 2:技能実習評価試験）。
export const OCCUPATION_EXAM_TYPE = {
  KENTEI: 1,
  HYOKA: 2,
} as const;

export type TOccupationExamType = valueOf<typeof OCCUPATION_EXAM_TYPE>;

export const OCCUPATION_TYPE_LABEL: Record<TOccupationType, string> = {
  [OCCUPATION_TYPE.CATEGORY]: "カテゴリ",
  [OCCUPATION_TYPE.SHOKUSHU]: "職種",
  [OCCUPATION_TYPE.SAGYO]: "作業",
};
